import React from 'react';
import { Col, Row } from 'antd';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import MyBarChart from './Barchart';
import { CompanyDashboardProps } from './constants';
import styles from './company.module.scss';
import { ContentType } from 'recharts/types/component/Label';
import { EmissionByLocationResponse } from 'models/MainDashboard/locationDashboard.model';

interface LocationBarChartProps {
  loading: boolean;
  locationData: EmissionByLocationResponse | undefined;
  locationOption: string;
  fetchEmissionByLocation: (params: {
    year: number;
    organizationId: number;
    locationId?: number;
  }) => void;
  firstYear: string;
  parentID: number;
  xAxisLabelContent: ContentType;
}

const LocationBarChart: React.FC<LocationBarChartProps> = ({
  loading,
  locationData,
  locationOption,
  fetchEmissionByLocation,
  firstYear,
  parentID,
  xAxisLabelContent,
}) => {
  return (
    <Row justify="space-around">
      <Col span={24}>
        <h5 className={styles.yoyEmissionTitle}>
          {CompanyDashboardProps.TOTAL_CO2}
        </h5>
        <div className={styles.locationCardContainer}>
          <div className={styles.breakdownChart}>
            {loading ? (
              <div className={styles.loaderContainer}>
                <LoaderAnimation />
              </div>
            ) : (
              <MyBarChart
                data={locationData}
                locationId={locationOption}
                fetchEmissionByLocation={fetchEmissionByLocation}
                year={Number(firstYear)}
                orgId={Number(parentID)}
                XAxisLabel={xAxisLabelContent}
                loading={loading}
              />
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default LocationBarChart;
